import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getFormStatus, getUploadStatus } from '../redux/selectors';

const getFormStatusSelector = createSelector(
  state => state,
  state => ({
    formStatus: getFormStatus(state),
    uploadStatus: getUploadStatus(state),
  })
);

export function useSubmitFormStatus() {
  const { formStatus, uploadStatus } = useSelector<any, any>(getFormStatusSelector);

  const isMainUploading = uploadStatus?.main === 'uploading';
  const isPcpUploading = uploadStatus?.pcp === 'uploading';
  const isExclusiveUploading = uploadStatus?.exclusive === 'uploading';
  const isFormBusy = ['fetching', 'submitting'].includes(formStatus);
  const isBusy = isMainUploading || isPcpUploading || isExclusiveUploading || isFormBusy;

  return {
    formStatus,
    uploadStatus,
    isMainUploading,
    isPcpUploading,
    isFormBusy,
    isBusy,
  };
}
